import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import DateSelect from '../components/ui/DateSelect';
import { useStudentPortal } from '../store/StudentPortalContext';
import { useSettings } from '../store/SettingsContext';
import StudentPortalBanner from '../components/student/StudentPortalBanner';

export default function StudentPortalLoginPage() {
  const navigate = useNavigate();
  const { signIn } = useStudentPortal();
  const { settings } = useSettings();
  const portalSettings = settings?.studentPortal || {};
  const [reference, setReference] = useState('');
  const [dob, setDob] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    const result = await signIn(reference, dob, password);
    if (result?.error) {
      setError(result.error);
      return;
    }
    navigate('/student-portal');
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'var(--sp-surface-alt)' }}>
      <div className="w-full max-w-md space-y-4">
        <StudentPortalBanner settings={portalSettings} />
        <Card className="p-6 w-full space-y-4">
        <div>
          <h2 className="sp-value" style={{ fontSize: '20px', fontWeight: 600 }}>Student Portal Sign In</h2>
          <p className="text-sm sp-muted">Use your student reference (or email). If you have a portal password, use it instead of DOB.</p>
        </div>
        {error && <div className="sp-alert sp-alert--critical text-sm">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="sp-label">Student reference or email</label>
            <input
              className="sp-input mt-2 w-full"
              value={reference}
              onChange={(event) => setReference(event.target.value)}
              placeholder="e.g. SP-1001 or name@email.com"
              required
            />
          </div>
          <div>
            <label className="sp-label">Portal password (if set)</label>
            <input
              className="sp-input mt-2 w-full"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
            />
            <div className="text-xs sp-muted mt-1">If you don’t have a password, use your date of birth below.</div>
          </div>
          <div>
            <label className="sp-label">Date of birth</label>
            <DateSelect value={dob} onChange={setDob} className="mt-2 w-full" />
          </div>
          <Button type="submit" className="w-full">Sign in</Button>
        </form>
        <div className="text-xs sp-muted">
          <a className="sp-link" href="/student-portal/reset">Have a reset link?</a>
        </div>
      </Card>
      </div>
    </div>
  );
}
